import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '@siat-fe/env';
import { Observable } from 'rxjs';
import { toDateKey } from '../calendar.utils';
import { isDateValidForEvent } from './event.service';

@Injectable({ providedIn: 'root' })
export class HolidaysService {
  /**
   * HttpClient
   */
  private readonly http = inject(HttpClient);

  /**
   * Base URL
   */
  private readonly baseUrl = environment.baseUrl;

  /**
   * Set of loaded years
   */
  private readonly loadedYears = new Set<number>();

  /**
   * Set of cached dates
   */
  private readonly cachedDates = signal<Set<string>>(new Set());

  /**
   * If true, only valid dates are allowed.
   */
  readonly blockHolidayInsert = signal<boolean>(false);

  /**
   * @returns { Observable<string[]> } of holidays.
   */
  getHolidays(anno: number, citta: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}v1/holidays`, {
      params: { anno, citta },
    });
  }

  /**
   * @param dates 
   */
  addHolidays(dates: string[]): void {
    this.cachedDates.update(prev => new Set([...prev, ...dates]));
  }

  /**
   * @param year 
   * @returns { boolean } if year has been loaded
   */
  isYearLoaded(year: number): boolean {
    return this.loadedYears.has(year);
  }

  /**
   * @param year 
   */
  markYearLoaded(year: number): void {
    this.loadedYears.add(year);
  }

  /**
   * @param date 
   * @returns { boolean } if date is a holiday
   */
  isHoliday(date: Date): boolean {
    return this.cachedDates().has(toDateKey(date));
  }

  /**
   * If blockHolidayInsert is true, only valid dates are allowed.
   * Otherwise, valid dates and not holidays are allowed.
   */
  isDateAllowed(date: Date): boolean {
    if (!this.blockHolidayInsert()) return isDateValidForEvent(date);
    return isDateValidForEvent(date) && !this.isHoliday(date);
  }
}
